import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import Header from '../../components/Header'
import auth from '../../utils/auth'
import Loader from '../vehicles/components/Loader'

const LogoutView = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        auth.logout()
        // Removed dispatch(getCurrentUser()) as it was causing problematic flow:
        // 1. auth.logout() clears tokens
        // 2. getCurrentUser() tries to fetch user WITHOUT tokens  
        // 3. This fails and triggers getCurrentUser.rejected
        // 4. Which calls onUnauthenticated() causing unnecessary logout loop
    }, [])

    return (
        <div>
            <Header center>Logging out</Header>
            <br />
            <Loader />
        </div>
    )
}

export default LogoutView
